import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import MergePartContent from "./MergePartContent";

export const MergePartDialog = () => {
  const name = "merge-customer-parts";

  return (
    <HubDialogWrapper maxWidth="sm" name={name}>
      <MergePartContent />
    </HubDialogWrapper>
  );
};

export default MergePartDialog;
